export default class Container {
  constructor(id) {
    this.id = id;
    this.node = document.querySelector(this.id);
  }

  get element() {
    if (this.node) return this.node;

    const {readyState} = document;

    if (
      (this.id && readyState === 'complete') ||
      readyState === 'interactive'
    ) {
      return document.querySelector(this.id);
    } else {
      return null;
    }
  }

  append(html) {
    if (!this.element) {
      console.error(`Could not append html to ${this.id}; element in null.`);
    }

    $(this.element).find('.filter-container').append(html);
    // this.element.insertAdjacentHTML("beforeEnd", html);
  }
}
